import styled from 'styled-components';

/**
 * The masked box. The glyph is a CSS `mask` cut from the SVG at `$src`; the
 * visible colour is `background-color` (default `currentColor`, normally
 * overridden by the consumer's icon class for the inactive/active tones), and
 * the size comes from the consumer's icon class too — exactly where the old
 * `.icon svg { width/height }` rules lived.
 */
export const MaskSpan = styled.span<{ $src: string }>`
  display: block;
  background-color: currentColor;
  -webkit-mask: url(${({ $src }) => $src}) center / contain no-repeat;
  mask: url(${({ $src }) => $src}) center / contain no-repeat;
`;
